import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import Icons from "@/pages/Icons.vue";
import Notifications from "@/pages/Notifications.vue";
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import Typography from "@/pages/Typography.vue";
import Clients from "@/pages/Clients";
import Login from "@/pages/Login";
import Directories from "@/pages/Directories";
import BaseTSR from "@/pages/BaseTSR";
import Compensations from "@/pages/Compensations";
import TSRs from "@/pages/TSRs";
import Products from "@/pages/Products";
import HotClients from "@/pages/HotClients";
import Loggs from "@/pages/Loggs";
import DocumentPatterns from "@/pages/DocumentPatterns";
import Calls from "@/pages/Calls.vue";

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/clients'
  },
  {
    path: '/login', component: Login
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/clients",
    children:[
      {
        path: "hot_clients",
        name: "Клиенты под обзвон",
        component: HotClients
      },
      {
        path: "clients",
        name: "Клиенты",
        component: Clients
      },
      {
        path: "calls",
        name: "Звонки",
        component: Calls
      },
      {
        path: "directories",
        name: "Справочники",
        component: Directories
      },
      {
        path: "tsrs",
        name: "ТСР",
        component: TSRs
      },
      {
        path: "base_tsrs",
        name: "Базовые ТСР",
        component: BaseTSR
      },
      {
        path: "compensations",
        name: "Компенсации",
        component: Compensations
      },
      {
        path: "loggs",
        name: "Логи",
        component: Loggs
      },
      {
        path: "doc_patterns",
        name: "Шаблоны документов",
        component: DocumentPatterns
      },
      {
        path: "products",
        name: "Номенклатура",
        component: Products
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "icons",
        name: "Icons",
        component: Icons
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications
      },
      {
        path: "user",
        name: "User Profile",
        component: UserProfile
      },
      {
        path: "table",
        name: "Table List",
        component: TableList
      },
      {
        path: "typography",
        name: "Typography",
        component: Typography
      }]
  }];

export default routes;
